import {
  Avatar,
  AvatarUserProps,
  AvatarComponentProps,
  cn,
} from '@fe-learner-common';
import { FC } from 'react';
import './AvatarGroup.css';

type AvatarGroupProps = AvatarComponentProps & {
  users: AvatarUserProps[];
  maxNoOfAvatars?: number;
};

const styleMap: Record<
  'xs' | 'md' | 'lg' | 'xl' | '2xl',
  {
    containerClassName: string;
    maskClassName: string;
  }
> = {
  xs: {
    containerClassName: 'h-5',
    maskClassName: '-ml-1.5 avatar-mask-xs',
  },
  md: {
    containerClassName: ' h-6',
    maskClassName: '-ml-2.5 avatar-mask-md',
  },
  lg: {
    containerClassName: ' h-8',
    maskClassName: '-ml-3 avatar-mask-lg',
  },
  xl: {
    containerClassName: 'h-10',
    maskClassName: '-ml-4 avatar-mask-xl',
  },
  '2xl': {
    containerClassName: ' h-[72px]',
    maskClassName: '-ml-6 avatar-mask-2xl',
  },
};

export const AvatarGroup: FC<AvatarGroupProps> = ({
  users,
  size,
  maxNoOfAvatars = 4,
}) => {
  const { containerClassName, maskClassName } = styleMap[size];

  const avatars = users.slice(0, maxNoOfAvatars);
  return (
    <div
      className={cn(
        'relative z-10 box-content flex flex-nowrap ',
        containerClassName,
      )}
    >
      {avatars.map((user, index) => (
        <Avatar
          className={cn(
            ' box-border border-2 border-transparent',
            index !== 0 && maskClassName,
          )}
          key={index}
          {...user}
          size={size}
        />
      ))}
    </div>
  );
};
